import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ApiError } from '@geefamily/api';

/**
 * Rendered when a route loader or a component below it throws. Shows the
 * correlation id when the failure came from the API, because that is the one
 * piece of information that makes a user report actionable.
 */
export function RouteError() {
  const error = useRouteError();

  const { title, detail, correlationId } = describe(error);

  return (
    <div role="alert" className="status-page text-center">
      <h1 className="text-2xl font-semibold text-surface-50">{title}</h1>
      <p className="mt-3 text-surface-400">{detail}</p>

      {correlationId ? (
        <p className="mt-6 font-mono text-xs text-surface-600">
          Referans: <span className="select-all">{correlationId}</span>
        </p>
      ) : null}

      <a href="/" className="gf-button gf-button-primary mt-8">
        Ana sayfaya dön
      </a>
    </div>
  );
}

function describe(error: unknown): {
  title: string;
  detail: string;
  correlationId?: string | undefined;
} {
  if (error instanceof ApiError) {
    return {
      title: error.isNotFound ? 'Sayfa bulunamadı' : 'Bir şeyler ters gitti',
      detail: error.message,
      correlationId: error.correlationId,
    };
  }

  if (isRouteErrorResponse(error)) {
    return {
      title: error.status === 404 ? 'Sayfa bulunamadı' : `Hata ${error.status}`,
      detail: error.statusText || 'Beklenmeyen bir hata oluştu.',
    };
  }

  return {
    title: 'Bir şeyler ters gitti',
    detail: 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
  };
}
